var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecordButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C6 8.67188 8.67188 6 12 6C15.3281 6 18 8.67188 18 12C18 15.3281 15.3281 18 12 18C8.67188 18 6 15.3281 6 12ZM10.5 12C10.5 12.8438 11.1562 13.5 12 13.5C12.8438 13.5 13.5 12.8438 13.5 12C13.5 11.1562 12.8438 10.5 12 10.5C11.1562 10.5 10.5 11.1562 10.5 12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 12C0.75 5.76562 5.76562 0.75 12 0.75C18.2344 0.75 23.25 5.76562 23.25 12C23.25 18.2344 18.2344 23.25 12 23.25C5.76562 23.25 0.75 18.2344 0.75 12ZM6 12C6 15.3281 8.67188 18 12 18C15.3281 18 18 15.3281 18 12C18 8.67188 15.3281 6 12 6C8.67188 6 6 8.67188 6 12Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordButton);
export default __webpack_public_path__ + "static/media/recordButton.334bca2bd83c6e8f282e7835e500f51a.svg";
export { ForwardRef as ReactComponent };